module.exports = __webpack_public_path__ + "media/svg-new/no-stop-icon-8965cd41.svg";